import { Fragment, h, JSX } from '@stencil/core';
import featureToggles from '@phn/services/feature-toggles';
import { navStateStore } from '@phn/state/nav-state-store';
import { getConfig } from '@phn/utility/helper';

export const NavigationDrawerScripts = (): JSX.Element | null => {
  const config = getConfig(navStateStore.state.env);

  if (featureToggles.isNaviDrawerFromCDNEnabled()) {
    return (
      <Fragment>
        <script type="module" src={`${config.PHN_DRAWER_CDN_URL}/navigation-drawer.esm.js`}></script>
        <script type="nomodule" src={`${config.PHN_DRAWER_CDN_URL}/navigation-drawer.js`}></script>
      </Fragment>
    );
  }

  return null;
};
